import { BlocksIconArrowTriangularRight } from 'blocks-nextjs/blocks-web-components/components/icon/icons/arrow-triangular-right';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconArrowTriangularRight = createComponent({
  react: React,
  tagName: 'cat-icon-arrow-triangular-right',
  elementClass: BlocksIconArrowTriangularRight
});
